var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge",attrs:{"title":_vm.relationDescription}},[_vm._v(" "+_vm._s(_vm.relationDescription))])
}
var staticRenderFns = []

export { render, staticRenderFns }